module.exports = __webpack_public_path__ + "media/images/redesign-images/essentials/look-inside-9946d7282fee0dba97ecdc994e08ee4c.png";